<template>
  <v-select
    :label="$t('Receipt.Fields.bill_types')"
    v-model="model"
    :items="billTypes"
    clearable
  ></v-select>
</template>

<script>
import consts from "@/consts.js";

export default {
  name: "SearcherSupplyType",
  props: { 
    value:Number,
    objType:Number
   },
  computed: {
    billTypes() {
      if(this.objType == 1){
        return consts.billTypes;
      }else{
        return consts.purchaseBillTypes
      }
    },
  },

  data: () => ({
    model: null,
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.model = this.value;
      },
    },
    model: {
      handler() {
        this.$emit("input", this.model);
      },
    },
  },
};
</script>
